import Head from 'next/head';
import { useRouter } from 'next/router';
import SEO from '@seo/index';
import TestSeriesListing from '@cont/SeeAll/TestSeriesListing/AllTestSeries';
import { getTopology } from '@selectors/topologies';
import subGoalSchema from '@seo/goal/subGoal';
import { fetchTestSeries } from '@actions/plusCourses';
import { fetchTopologyInfo } from '@actions/topologies';
import { useSetSelectedNav } from '@stores/sidenav';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getValidTestType } from '@cont/SeeAll/utils';
import { ALL_TEST_SERIES } from '@constants/segment';
import { emptyObject } from '@constants/empty';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/index';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import { usePageSeoContent } from '@stores/AppCommonData';

const TestSeries = () => {
  const router = useRouter();
  const {
    query: { goalUID }
  } = router;

  const { title, description } = usePageSeoContent();
  const goalInfo = useSelectorWithShallowEqual((state) =>
    getTopology(state, goalUID)
  );

  const { goalSlug, uid, thumbnail, ogImage } = goalInfo || emptyObject;

  const metaTitle = title || `All Test Series | ${goalInfo.title} | Unacademy`;
  const canonicalURL = `https://unacademy.com/goal/${goalSlug}/${uid}/test-series/all`;

  useSetSelectedNav('test-series');

  return (
    <>
      <SEO
        title={metaTitle}
        description={description}
        openGraph={{
          title,
          description,
          images: [
            {
              url: ogImage || thumbnail
            }
          ],
          url: canonicalURL
        }}
        schema={subGoalSchema({
          goal: goalInfo,
          description,
          subGoal: { name: 'Test series', link: 'test-series' }
        })}
      />
      <Head>
        <title>{metaTitle}</title>
      </Head>
      <TestSeriesListing />
    </>
  );
};

TestSeries.pageInfo = {
  isMWebSupported: true,
  name: ALL_TEST_SERIES,
  layoutOptions: {
    hideFooter: true,
    showPlusNav: true
  },
  isCMSMeta: true
};

TestSeries.getInitialProps = setupInitialProps(async ({ store, query }) => {
  const { goalUID, 'test-type': testType } = query;

  const initalType = getValidTestType(testType);
  const promises = [store.dispatch(fetchTestSeries(goalUID, initalType))];

  if (!getTopology(store.getState(), goalUID)) {
    promises.push(store.dispatch(fetchTopologyInfo(goalUID)));
  }

  await Promise.all(promises);
}, TestSeries.pageInfo);

export default TestSeries;
TestSeries.Layout = Layout;
TestSeries.Wrapper = PageReduxProvider;
